import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '@/api/index';
import { BASE_URL, defaultHeaders } from '@/constants/index';

// Define a service using a base URL and expected endpoints
export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['STOCK'],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ lang }) => ({
        url: 'mno-product/product',
        method: 'GET',
        params: {
          size: 12,
          page: 0,
        },
        headers: { 'Content-Language': lang, ...defaultHeaders },
        baseURL: BASE_URL,
      }),
      transformResponse: (response) => ({
        cin: response.data[0].tariffs,
        klass: response.data[1].tariffs,
      }),
    }),
  }),
});

export const hooks = {
  useGetProducts: productApi.useGetProductsQuery,
};

export default productApi;
